import { ApolloClient, InMemoryCache } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';
import { apolloLink } from '../../../shared/data/apolloClient';

const dashboardMapApolloClient = new ApolloClient({
  link: apolloLink,
  cache: new InMemoryCache({
    typePolicies: {
      Organization: {
        fields: {
          alerts: relayStylePagination(),
        },
      },
    },
  }),
});

export default dashboardMapApolloClient;
